<template>
    <div id="app">

        <Head></Head>
        <div class="banner">
            <img v-if="this.$store.state.currentLang === 'zh'" :src="this.$path + '/assets/images/banner-tricycle-zh.png'"
                :alt="$t('langs.aolei')" />
            <img v-if="this.$store.state.currentLang === 'en'" :src="this.$path + '/assets/images/banner-tricycle-en.png'"
                :alt="$t('langs.aolei')" />
        </div>
        <div class="box_center_pd">
            <span class="text_pd">{{ $t("langs.tricyclebms") }}</span>
        </div>
        <div class="row_line">
            <span class="td_line"></span>
        </div>
        <div class="word_detail_tricycle">
            {{ $t("langs.detailtricycleone") }}
        </div>
        <div class="word_detail_tricycle">
            {{ $t("langs.detailtricycletwo") }}
        </div>
        <div class="center_center">
            <div class="main_images">
                <img :src="this.$path + '/assets/images/main_tricycle.png'" />
                <img :src="this.$path + '/assets/images/main_tricycle_one.png'" />
                <img :src="this.$path + '/assets/images/main_tricycle_two.png'" />
            </div>
        </div>
        <div class="box_center_pd">
            <span class="text_pd">{{ $t("langs.features") }}</span>
        </div>
        <div class="row_line">
            <span class="td_line"></span>
        </div>
        <div class="tricycle_center">
            <div :class="active1 ? 'imge_block2 img_bottom2' : 'imge_block1 img_bottom1'" @mouseover="mouseOver(1)"
                @mouseleave="mouseLeave">
                <img v-if="!active1" :src="this.$path + '/assets/images/center_image_1.png'" />
                <img v-else :src="this.$path + '/assets/images/center_image_11.png'" />
                <div v-if="!active1" class="image_backg_text">
                    <span style="padding-top: 40%;">BMS</span><span>+</span><span>{{ $t("langs.internet")
                    }}</span><span>+</span><span>{{ $t("langs.bigdata") }}</span>
                </div>
                <div v-else class="image_backg_text_one"><span style="padding-top: 20%;">BMS+{{ $t("langs.internet")
                }}+{{ $t("langs.bigdata") }}</span>
                    <template v-if="this.$store.state.currentLang === 'zh'">
                        <span class="text_two">{{ $t("langs.tricycleimgdetailed1") }}</span>
                    </template>
                    <template v-else>
                        <span class="text_two_en">{{ $t("langs.tricycleimgdetailed1") }}</span>
                    </template>
                </div>
            </div>
            <div :class="active2 ? 'imge_block2 img_top2' : 'imge_block1 img_top1'" @mouseover="mouseOver(2)"
                @mouseleave="mouseLeave">
                <img v-if="!active2" :src="this.$path + '/assets/images/center_image_2.png'" />
                <img v-else :src="this.$path + '/assets/images/center_image_22.png'" />
                <div v-if="!active2" class="image_backg_text"><span style="padding-top: 60%;">{{ $t("langs.lowcost")
                }}</span><span>{{ $t("langs.safeuse") }}</span></div>
                <div v-else class="image_backg_text_one"><span style="padding-top: 20%;">{{
                        $t("langs.lowcostandsafeuse")
                }}</span>
                    <template v-if="this.$store.state.currentLang === 'zh'">
                        <span class="text_two">{{ $t("langs.tricycleimgdetailed2") }}</span>
                    </template>
                    <template v-else><span class="text_two_en">{{ $t("langs.tricycleimgdetailed2") }}</span>
                    </template>
                </div>
            </div>
            <div :class="active3 ? 'imge_block2 img_bottom2' : 'imge_block1 img_bottom1'" @mouseover="mouseOver(3)"
                @mouseleave="mouseLeave">
                <img v-if="!active3" :src="this.$path + '/assets/images/center_image_3.png'" />
                <img v-else :src="this.$path + '/assets/images/center_image_33.png'" />
                <div v-if="!active3" class="image_backg_text"><span style="padding-top: 70%;">{{
                        $t("langs.securityalarm")
                }}</span></div>
                <div v-else class="image_backg_text_one"><span style="padding-top: 20%;">{{ $t("langs.securityalarm")
                }}</span>
                    <template v-if="this.$store.state.currentLang === 'zh'">
                        <span class="text_two">{{ $t("langs.tricycleimgdetailed3") }}</span>
                    </template>
                    <template v-else><span class="text_two_en">{{ $t("langs.tricycleimgdetailed3") }}</span></template>
                </div>
            </div>
            <div :class="active4 ? 'imge_block2 img_top2' : 'imge_block1 img_top1'" @mouseover="mouseOver(4)"
                @mouseleave="mouseLeave">
                <img v-if="!active4" :src="this.$path + '/assets/images/center_image_4.png'" />
                <img v-else :src="this.$path + '/assets/images/center_image_44.png'" />
                <div v-if="!active4" class="image_backg_text"><span style="padding-top: 70%;">{{
                        $t("langs.communicationcontrol")
                }}</span></div>
                <div v-else class="image_backg_text_one"><span style="padding-top: 20%;">{{
                        $t("langs.communicationcontrol")
                }}</span>
                    <template v-if="this.$store.state.currentLang === 'zh'">
                        <span class="text_two">{{ $t("langs.tricycleimgdetailed4") }}</span>
                    </template>
                    <template v-else>
                        <span class="text_two_en">{{ $t("langs.tricycleimgdetailed4") }}</span>
                    </template>
                </div>
            </div>
            <div :class="active5 ? 'imge_block2 img_bottom2' : 'imge_block1 img_bottom1'" @mouseover="mouseOver(5)"
                @mouseleave="mouseLeave">
                <img v-if="!active5" :src="this.$path + '/assets/images/center_image_5.png'" />
                <img v-else :src="this.$path + '/assets/images/center_image_55.png'" />
                <div v-if="!active5" class="image_backg_text"><span style="padding-top: 60%;">{{
                        $t("langs.remotecontrol")
                }}</span><span>{{ $t("langs.upgradepowerfailure") }}</span></div>
                <div v-else class="image_backg_text_one"><span style="padding-top: 20%;">{{
                        $t("langs.remotecontrolupgrade")
                }}</span>
                    <template v-if="this.$store.state.currentLang === 'zh'">
                        <span class="text_two">{{ $t("langs.tricycleimgdetailed5") }}</span>
                    </template>
                    <template v-else>
                        <span class="text_two_en">{{ $t("langs.tricycleimgdetailed5") }}</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="tricycle_center_pd">
            <span class="text_pd">{{ $t("langs.scopeofapplication") }}</span>
            <div class="row_line">
                <span class="td_line"></span>
            </div>
            <img v-if="this.$store.state.currentLang === 'zh'" :src="this.$path + '/assets/images/power-scope-tricycle-zh.png'"
                class="application_image" :alt="$t('langs.scopeofapplication')" />
            <img v-if="this.$store.state.currentLang === 'en'" :src="this.$path + '/assets/images/power-scope-tricycle-en.png'"
                class="application_image" :alt="$t('langs.scopeofapplication')" />
        </div>
        <div class="box_center_pd">
            <span class="text_pd">{{ $t("langs.parameter") }}</span>
            <div class="row_line">
                <span class="td_line"></span>
            </div>
            <img v-if="this.$store.state.currentLang === 'zh'" :src="this.$path + '/assets/images/power-parameter-tricycle-zh.png'"
                class="tricycle_image" :alt="$t('langs.parameter')" />
            <img v-if="this.$store.state.currentLang === 'en'" :src="this.$path + '/assets/images/power-parameter-tricycle-en.png'"
                class="tricycle_image" :alt="$t('langs.parameter')" />
        </div>
        <Footer></Footer>
        <Hover></Hover>
    </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover';

export default {
    name: "centerbms",
    components: { Head, Footer,Hover },
    data() {
        return {
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: false
        };
    },
    methods: {
        // 移入
        mouseOver(index) {
            if (index == 1) {
                this.active1 = true;
            }
            if (index == 2) {
                this.active2 = true;
            }
            if (index == 3) {
                this.active3 = true;
            }
            if (index == 4) {
                this.active4 = true;
            }
            if (index == 5) {
                this.active5 = true;
            }
        },
        // 移出
        mouseLeave() {
            this.active1 = false;
            this.active2 = false
            this.active3 = false
            this.active4 = false
            this.active5 = false
        }
    }
};
</script>

<style>
@import "../assets/css/center.css";

.word_detail_tricycle {
    font-size: 16px;
    color: rgba(102, 102, 102, 1);
    line-height: 22px;
    padding: 15px 15%;
}

.application_image {
    margin-top: 3%;
    width: 1024px !important;
    height: 925px !important;
}

.tricycle_image {
    margin-top: 3%;
    width: 1026px !important;
    height: 1271px !important;
}

.tricycle_center {
    width: auto;
    display: flex;
    margin-top: 40px;
    text-align: center;
    justify-content: center;
}

.imge_block1 {
    float: left;
    display: block;
    height: 470px !important;
    width: 205px !important;
}

.imge_block2 {
    float: left;
    display: block;
    height: 470px !important;
    width: 205px !important;
}

.img_top1 {
    display: inline-block;
    height: 400px;
    width: 204px;
}

.img_top2 {
    display: inline-block;
    height: 430px;
    width: 330px;
    transform: translate(-30%, -4%);
    position: relative;
    z-index: 999;
}

.img_bottom1 {
    display: inline-block;
    height: 400px;
    width: 204px;
    margin-top: 40px;
}

.img_bottom2 {
    display: inline-block;
    height: 430px;
    width: 330px;
    margin-top: 40px;
    transform: translate(-30%, -2%);
    position: relative;
    z-index: 999;
}

.tricycle_center_pd {
    width: 100%;
    text-align: center;
    overflow-wrap: break-word;
    white-space: nowrap;
    margin-top: 30px;
    display: inline-block;
}

.image_backg_text {
    position: relative;
    width: 100%;
    height: 80%;
    margin-top: -400px;
}

.image_backg_text span {
    display: block;
    font-weight: 500;
    color: #FFFFFF;
    font-size: 24px;
}

.image_backg_text_one {
    position: relative;
    width: 300px;
    transform: translate(5%, -2%);
    height: 80%;
    margin-top: -400px;
}

.image_backg_text_one span {
    display: block;
    font-weight: 500;
    color: #FFFFFF;
    font-size: 24px;
}

.text_two {
    font-size: 18px !important;
    font-weight: 400 !important;
    line-height: 28px;
    padding-top: 5px;
    padding-left: 12%;
    padding-right: 12%;
}

.text_two_en {
    font-size: 17px !important;
    font-weight: 400 !important;
    line-height: 25px;
    padding-top: 2px;
    padding-left: 2%;
    padding-right: 2%;
}
</style>


// WEBPACK FOOTER //
// src/view/center_motorcycle.vue